import { useState, useEffect } from 'react';

function PaymentCTA({ onOpenPayment, onOpenPaymentPage, pricing = { price1Friend: 4000 } }) {
  const [timeLeft, setTimeLeft] = useState({ minutes: 4, seconds: 58 });

  const price1 = pricing.price1Friend;
  const originalPrice1 = price1 * 2.5;
  const discount1 = Math.round((1 - price1 / originalPrice1) * 100);
  const savings1 = originalPrice1 - price1;

  const formatPrice = (num) => '₹' + Number(num).toLocaleString('en-IN');

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return { ...prev, seconds: prev.seconds - 1 };
        if (prev.minutes > 0) return { minutes: prev.minutes - 1, seconds: 59 };
        return { minutes: 4, seconds: 58 };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="max-w-2xl mx-auto my-12 px-4">
      <div className="grid grid-cols-1 gap-6 items-stretch">
        {/* Card 1 - Single Seat ₹4,000 */}
        <div className="relative group h-full">
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/40 via-orange-500/40 to-amber-500/40 rounded-3xl blur-xl opacity-60"></div>
          <div className="relative bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 rounded-3xl border border-amber-500/30 p-6 text-center overflow-hidden shadow-2xl h-full flex flex-col justify-between">
            <div>
              {/* Spacer for badge alignment */}
              <div className="h-6 mb-2"></div>
              
              {/* Timer */}
              <div className="mb-4">
                <p className="text-gray-400 text-xs mb-3 uppercase tracking-widest font-medium">Offer Expires In</p>
                <div className="flex items-center justify-center gap-2">
                  <div className="relative">
                    <div className="absolute inset-0 bg-red-500 rounded-xl blur-sm opacity-40"></div>
                    <div className="relative bg-gradient-to-br from-red-500 to-red-700 text-white w-14 h-14 rounded-xl flex items-center justify-center text-2xl font-black shadow-lg border border-red-400/30">
                      {String(timeLeft.minutes).padStart(2, '0')}
                    </div>
                    <p className="text-gray-500 text-[9px] mt-1 uppercase tracking-wider">Minutes</p>
                  </div>
                  <span className="text-2xl font-black text-amber-500 animate-pulse mb-5">:</span>
                  <div className="relative">
                    <div className="absolute inset-0 bg-red-500 rounded-xl blur-sm opacity-40"></div>
                    <div className="relative bg-gradient-to-br from-red-500 to-red-700 text-white w-14 h-14 rounded-xl flex items-center justify-center text-2xl font-black shadow-lg border border-red-400/30">
                      {String(timeLeft.seconds).padStart(2, '0')}
                    </div>
                    <p className="text-gray-500 text-[9px] mt-1 uppercase tracking-wider">Seconds</p>
                  </div>
                </div>
              </div>

              {/* Warning */}
              <p className="text-red-400 text-sm md:text-base font-bold mb-4">
                Price rises to {formatPrice(originalPrice1)} after timer ends!
              </p>

              {/* Pricing */}
              <div className="mb-4">
                <p className="text-red-500 line-through text-xl font-black">{formatPrice(originalPrice1)}</p>
                <div className="flex items-center justify-center gap-2">
                  <span className="text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">
                    {formatPrice(price1)}
                  </span>
                  <span className="bg-green-500/20 text-green-400 text-xs font-bold px-2 py-1 rounded-full border border-green-500/30">
                    {discount1}% OFF
                  </span>
                </div>
                <p className="text-green-400 font-semibold mt-2 flex items-center justify-center gap-1 text-sm">
                  <span>🎉</span> Save {formatPrice(savings1)} Today!
                </p>
              </div>
            </div>

            {/* CTA Button */}
            <button 
              onClick={() => onOpenPaymentPage ? onOpenPaymentPage(price1) : onOpenPayment()}
              className="group/btn relative inline-flex items-center justify-center w-full py-4 px-6 text-base font-bold text-black bg-gradient-to-r from-amber-400 via-yellow-400 to-orange-500 rounded-xl shadow-lg shadow-amber-500/30 overflow-hidden transition-all duration-300 hover:scale-[1.02] hover:shadow-amber-500/50"
            >
              <span className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 -translate-x-full group-hover/btn:translate-x-full transition-transform duration-700"></span>
              <span className="relative flex items-center gap-2">
                Yes, I Want This
                <svg className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </span>
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}

export default PaymentCTA;
